/**
=========================================================
* Material Dashboard 2 React - v2.2.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-react
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

// @mui material components
import Grid from "@mui/material/Grid";

// Material Dashboard 2 React components
import MDBox from "components/MDBox";

// Material Dashboard 2 React example components
import DashboardLayout from "../../examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "../../examples/Navbars/DashboardNavbar";
import Footer from "../../examples/Footer";

// Data

import reportsLineChartData from "../../layouts/dashboard/data/reportsLineChartData";

// Dashboard components
import useSWR from "swr";
import Box from "@mui/material/Box";
import EditIcon from "@mui/icons-material/Edit";
import SaveIcon from "@mui/icons-material/Save";
import CancelIcon from "@mui/icons-material/Close";
import { DataGrid } from "@mui/x-data-grid";
import Tooltip from "@mui/material/Tooltip";
import IconButton from "@mui/material/IconButton";
import { MdOutlinePreview } from "react-icons/md";
import { useNavigate } from "react-router-dom";
import { FaEdit } from "react-icons/fa";
import { MdDelete } from "react-icons/md";
import Button from "@mui/material/Button";
import { baseURL, baseUrl } from "utils/api";
import { useEffect } from "react";
import { useMemo } from "react";
// import RemoveRedEyeIcon from "@mui/icons-material/RemoveRedEye";
import ReactLoading from "react-loading";
import {
  GridRowModes,
  GridToolbarContainer,
  GridActionsCellItem,
  GridRowEditStopReasons,
} from "@mui/x-data-grid";
import { useState } from "react";
import LoaderComponent from "components/Loader";
import axios from "axios";
import { CircularProgress, LinearProgress, Typography } from "@mui/material";
import httpClientReq from "services/httpClient";
import * as XLSX from 'xlsx';


function LinearProgressWithLabel(props) {

  return (
    <Box sx={{ display: "flex", alignItems: "center" }}>
      <Box sx={{ width: "100%", mr: 1 }}>
        <LinearProgress variant="determinate" {...props} />
      </Box>
      <Box sx={{ minWidth: 35 }}>
        <Typography variant="body2" color="text.secondary">{`${Math.round(
          props.value
        )}%`}</Typography>
      </Box>
    </Box>
  );
}

function MasterProductList() {
  const navigate = useNavigate();
  const [file, setFile] = useState("");
  const [formLoading, setFormLoading] = useState("");
  const [detail, setDetails] = useState(null);
  // const handleNavigateToDetails = (data) => {
  //   if (data) {
  //     setDetails(data);
  //     navigate("/view_details", { state: detail });
  //   }
  // };

  // const [tableData, setTableData] = useState([]);

  // const getapi = async () => {
  //   try {
  //     const response = await axios.get(
  //       "https://jumunona.onrender.com/admin/products/getProducts?page=1"
  //     );
  //     return response.data;
  //   } catch (error) {
  //     console.error("Error fetching data:", error);
  //     throw error;
  //   }
  // };

  // const callData = async () => {
  //   setFormLoading(true);
  //   try {
  //     const response = await getapi();
  //     setTableData(response?.data?.products || []);
  //     setFormLoading(false);
  //   } catch (error) {
  //     setFormLoading(false);
  //   }
  // };

  // useEffect(() => {
  //   callData();
  // }, []);

  // const fetchData = async (uRL) => {
  //   try {
  //     const response = await axios.get(uRL);
  //     console.log("in fetch");
  //     return response.data;
  //   } catch (error) {
  //     console.log(error);
  //   }
  // };

  // const { <data, error } = useSWR(`${baseURL}/products/getProducts?page=1`, fetchData, {
  //   refreshInterval: 500,
  // });
  // const [rows, setRows] = useState([]);
  // if (tableData != undefined){
  //   console.log(tableData, "sdasdad");
  // setRows(tableData?.map((mydata) => ({
  //   ...mydata,
  // }))
  //   );}

  const [loading, setLoading] = useState(true); // Introduce loading state

  const [tableData, setTableData] = useState([]);
  const [Userdata, setUserdata] = useState([]);
  const [totalRows, setTotalRows] = useState(0);
  const [page, setPage] = useState({ page: 1, pageSize: 10 });
  const [uploadingFile, setUploadingFile] = useState(0);
  // console.log("dataa", page);
  // useEffect(() => {
  //   const fetchData = async () => {
  //     try {
  //       const response = await axios.get(
  //         `https://jumunona.onrender.com/admin/products/getProducts?page=${page}`
  //       );
  //       console.log("Full Response:", response);
  //       const data = response?.data?.data?.products || [];
  //       setUserdata(data);
  //       setTotalRows(totalItems);
  //       setPage(page);
  //      // console.log("Roaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaws:", rows);
  //      } catch (error) {
  //       console.error("Error fetching data:", error);
  //     }
  //   };

  //   fetchData();
  // }, [page]);

  const fetchDataForMultiplePages = async () => {
    try {
      let allUserData = [];
      let totalItems = 0;
      console.log(page,'PAGE')
      // for (let page = 1; page <= 10; page++) {
        // const response = await axios.get(
        //   `https://jumunona.onrender.com/admin/products/getProducts?page=${page.page}&limit=${page.pageSize}`
        // );
        const response= await httpClientReq.get(`/products/getProductsV3?page=${page.page}&limit=${page.pageSize}`);
        console.log(response,'Response');
        const data = response?.data?.products || [];
        console.log( response?.data?.totalProducts,' response?.data?.pages?.totalProducts')
        const total = response?.data?.totalProducts || 0;
        allUserData = [...allUserData, ...data];
        totalItems = total;
      // }

      setUserdata(allUserData);
      setLoading(false);

      setTotalRows(totalItems);
    } catch (error) {
      console.error("Error fetching data:", error);
      setLoading(false);
    }
  };
  
  useEffect(() => {
    fetchDataForMultiplePages();
  }, [page]);

 
  const [rowModesModel, setRowModesModel] = useState({});
  const [updatedNewRow, setUpdatedRow] = useState(null);
  const processRowUpdate = async (newRow) => {
    const updatedRow = { ...newRow, isNew: false };
    setUpdatedRow(updatedRow);
    console.log(newRow);
    await handleUpdateProduct(newRow.product_id, newRow);
    setRows(rows.map((row) => (row.id === newRow.id ? updatedRow : row)));

    return updatedNewRow;
  };

  const handleRowEditStop = (params, event) => {
    if (params.reason === GridRowEditStopReasons.rowFocusOut) {
      event.defaultMuiPrevented = true;
    }
  };

  // const [allIds, setAllIds] = useState([]);

  const createdDate = new Date();
  const createdTime = createdDate.toLocaleTimeString([], { hour12: true });

  const handleEditClick = (_id) => () => {
    setRowModesModel({ ...rowModesModel, [_id]: { mode: GridRowModes.Edit } });
  };

  const handleCancelClick = (_id) => () => {
    setRowModesModel({
      ...rowModesModel,
      [_id]: { mode: GridRowModes.View, ignoreModifications: true },
    });
  };
  // const handleSaveClick = async (_id, categoryData) => {
  //   setRowModesModel({ ...rowModesModel, [_id]: { mode: GridRowModes.View } });
  // };
  const [allIds, setAllIds] = useState([]);

  const onRowsSelectionHandler = (_ids) => {
    console.log(_ids,'_ids');
    const selectedRowsData = _ids.map((_id) => rows.find((row) => row._id === _id));
    const foundIds = selectedRowsData.map((d) => d._id);
    setAllIds(foundIds);
  };

  const handleDeleteSelectedRows = async () => {
    let result = confirm("Are you sure you want to delete?");
    if (!result) {
      return;
    }
    try {
      setFormLoading(true);
      const res = await axios.post(`${process.env.REACT_APP_BASE_URL}/product/delete/products`, {
        ids: allIds,
      });

      setFormLoading(false);
    } catch (error) {
      setFormLoading(false);
    }
  };

  const handleRowModesModelChange = (newRowModesModel) => {
    setRowModesModel(newRowModesModel);
  };

  async function handleUpdateProduct(id, obj) {
    try {
      setFormLoading(true);

      const res =  axios.put(
        `${process.env.REACT_APP_BASE_URL}/products/updateProductValues/${id}`,
        {
          ...obj,
        },
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      if (res.status === 200) {
        setFormLoading(false);
      }
      setFormLoading(false);
    } catch (error) {
      setFormLoading(false);
      console.log(error);
    }
  }

  const [ruSubject, setRuSubject] = useState("");
  const [quantity, setQuantity] = useState("");
  const [price, setPrice] = useState("");
  const [mOQ, setMOQ] = useState("");
  const [status, setStatus] = useState("");
  const handleSubmit = async (id,row) => {
    // event.preventDefault();
    setRowModesModel({ ...rowModesModel, [id]: { mode: GridRowModes.View } });
  };

  const handlePriceChange = (e) => {
    setMOQ(e.target.value);
  };

  // ----------------------Chose Ecel file-------------------------------------//

  const [rowData, setRowData] = useState("");
  const handleFileChange = (event) => {
    setFile(event.target.files[0]);
  };

  // const handleSubmitFile = async () => {
  //   if (!file) return;

  //   const formData = new FormData();
  //   formData.append("file", file);
  //   setUploadingFile(1);
  
  //   const options = {
  //     onUploadProgress: progressEvent => {
  //         const { loaded, total } = progressEvent;

  //         let percent = Math.floor((loaded * 100) / total);
  //         console.log(`${loaded}kb of ${total}kb | ${percent}%`);

  //         if (percent < 100) {
  //           setUploadingFile(percent);
  //         }
  //     }
  // };
  //   try {
  //     const response = await axios.post("https://jumunona.onrender.com/admin/products/uploadProducts", 
  //       formData,
  //       options

  //     );

  //     if (response.ok) {
  //       const data = await response.json();
  //       setRowData(data); // Assuming the response data is an array of objects
  //       setUploadingFile(100);
  //       setTimeout(()=>{
  //         setUploadingFile(0);

  //       },1000);
        

  //     } else {
  //       console.error("Failed to upload file");
  //       setUploadingFile(0);

  //     }
  //   } catch (error) {
  //     console.error("Error uploading file:", error);
  //     setUploadingFile(0);

  //   }
  // };
  const handleSubmitFile = async (e) => {
    e.preventDefault();
    const formData = new FormData();
    formData.append("file", file);
    handleFileUpload(e, file);
    // try {
    //     setFormLoading(true);
    //     const res = await axios.post(`${baseUrl}/admin/upload-category`, formData);
    //     console.log(res);
    //     if (res.status === 200) {

    //         setFormLoading(false);

    //         navigate("/");
    //     }
    // } catch (error) {
    //     setFormLoading(false);

    //     console.log(error);
    // }
};
  function handleFileUpload(event, exclFile) {
    const file = exclFile;
    const reader = new FileReader();

    reader.onload = async function (event) {
      // Parse data
      const bstr = event.target.result;
      const workbook = XLSX.read(bstr, { type: 'binary' });

      // Get first worksheet
      const worksheetName = workbook.SheetNames[0];
      const worksheet = workbook.Sheets[worksheetName];


      // Convert to JSON
      const jsonData = XLSX.utils.sheet_to_json(worksheet, {
        raw: false, // Include formatted text in cells
        defval: ''  // Default value for missing keys (blank keys)
      });
      console.log(jsonData, 'JsonData');
      const payload = jsonData.map((item) => {
        let transformedItem = {
          product_id: item.productID,
          name: item.RUsubject,
          RUattributes: item.RUattributes,
          supplierId: item.supplierUserId,
          supplierAddtress: item.sendGoodsAddressText,
          unitWeight: item.unitWeight,
          suttleWeight: item.suttleWeight,
          width: item.width,
          height: item.height,
          length: item.length,
          unit: item.unit,
          sumCarriage: item.sumCarriage,
          categoryId: item.categoryID,// Assuming categoryId is fixed
          mOQ: parseInt(item.minOrderQuantity),
          quantity: parseInt(item.quantity),
          mainImages: item.imagesPath.split(','),
          descriptionImages: item.descriptionPath.split(','),
          attr1Value: item._attributeValue,
          attr1Image: item.skuImageUrlPath,
          sku_id: item._skuId,
          sku_quantity: item._amountOnSale,
          price: item._price,
          attr2Value: item._attributeValue2,
          attr3Value: item._attributeValue3
        };
        return (transformedItem)
      })
      try {
        setFormLoading(true);
        const res = await axios.post(`${process.env.REACT_APP_BASE_URL}/products/updateProductsV3`,{products:payload });
        console.log(res);
        if (res.status === 200) {

          setFormLoading(false);

          navigate("/");
        }
      } catch (error) {
        console.error("Error uploading file:", error);
        setUploadingFile(0);

      }
    };

    reader.readAsBinaryString(file);
  }

  //------------------------------DELETE------------------------------------------//
  const [deleteStatus, setDeleteStatus] = useState(false);
  const [_id, set_Id] = useState("");
  const [productId, setProductId] = useState("");
  const handleDeleteConfirmation = async (_id) => {
    try {
      const response = await fetch(`${process.env.REACT_APP_BASE_URL}/products/deleteProduct`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          productId: _id,
        }),
      });
      fetchDataForMultiplePages();
      const data = await response.json();
      console.log(data);
      console.log(_id, "AAAAAAAAAAA");

      if (data.success) {
        setDeleteStatus(true);
        set_Id("");
        setProductId("");
        window.location.reload();
      }
    } catch (error) {
      console.error("Error deleting product:", error);
    }
  };

  const handleDeleteButtonClick = (_id) => {
    const isConfirmed = window.confirm("Are you sure you want to delete this product?");
    if (isConfirmed) {
      handleDeleteConfirmation(_id); // Pass _id to handleDeleteConfirmation
    }
  };
  const handleChecked = (productId, isCheck) => {
    debugger
    // Find the product with the specified _id
    const productToUpdate = products.find(product => product._id === productId);

    // Check if productToUpdate exists
    if (productToUpdate) {
      // Update the isCheck field
      productToUpdate.isCheck = isChecked;
      console.log("Product updated:", productToUpdate);
    } else {
      console.log("Product not found with ID:", productId);
    }
  }

  const rows = useMemo(
    () =>
      Userdata &&
      Userdata.map((data, index) => ({
        ...data,
        id: data._id,
      }))
  );
  const ProductRenderingColumn=(param)=>{
    const detailsObj = { ...param.row };
        // console.log(param, "AAAAA");
        const fieldsToIgnore = ["attr1", "attr2", "attr3"];
        fieldsToIgnore.forEach((field) => delete detailsObj[field]);
        const [openPriceModal,setOpenPriceModal]=useState(false);
        const closePriceModal=()=>{
          setOpenPriceModal(false);
        }
        return (
          <>
            <div style={{ display: "flex", gap: "6px" }}>
              <Tooltip
                onClick={() => navigate("/view_details", { state: detailsObj })}
                title="view"
              >
                <IconButton>
                  <MdOutlinePreview style={{ cursor: "pointer" }} />
                </IconButton>
              </Tooltip>
              
              <Tooltip
                onClick={() =>{
                  console.log(param.row,'ParmaROW123')
                  navigate(
                    `/edit_product/${param.row.product_id}`,
                    console.log({ state: { productId: param.row._id } }),
                    "AAAAAAAA"
                  )
                }}
                title="Edit"
              >
                <IconButton>
                  <FaEdit className="text-blue-400" style={{ cursor: "pointer" }} />
                </IconButton>
              </Tooltip>
              <Tooltip title="Delete">
                <IconButton onClick={() => handleDeleteButtonClick(param.row._id)}>
                  <MdDelete className="text-red-400" style={{ cursor: "pointer" }} />
                </IconButton>
              </Tooltip>
              {/* {deleteStatus && (
                <div className="popup">
                  <p>Id is deleted successfully!</p>
                  <button onClick={resetDeleteStatus}>Close</button>
                </div>
              )} */}
              {/* <button onClick={handleDelete}>
      Delete Product
    </button> */}
            </div>
            {/* <ModalComponent
            title={"Price Details"}
            open={openPriceModal}
            handleClose={closePriceModal}
          >
           
           <div>
            <input type="text" />
            <input type="text" />
            <input type="text" />
            <input type="text" />
            <input type="text" />
           </div>
          </ModalComponent> */}
          </>
        );
  }
  const columns = [
    // { field: "_id", headerName: "ID", width: 90, hideable: true },
    {
      field: "isChecked",
      headerName: "Check",
      width: 100,
      renderCell: (params) => {
        return (
            <input    
              disabled        
              type="checkbox"
              checked={params.row.isChecked}
              // onClick={(e) => handleChecked(_id, e) }
            />          
        );
      },
    },
    { field: "product_id", headerName: "Prd. ID", width: 150 },
    {
      field: "name",
      headerName: "Prd. Name",
      width: 200,
      editable: true,
    },
    {
      field: "mainImages",
      headerName: "Prd. Image",
      width: 150,
      renderCell: (param) => {
        return (
          <div className="flex" style={{ marginLeft: "-10%" }}>
            {Array.isArray(param.row.mainImages) &&
              param.row.mainImages.map((imageUrl, index) => (
              <>
              
               { index==0?<img
                  key={index}
                  src={imageUrl}
                  className="h-[7vh] w-[6vw] object-contain mr-2"
                  alt={`Product Image ${index + 1}`}
                />:null}
              </>

              ))}
              
            {/* {!Array.isArray(param.row.mainImages) && (
              <img
                src={param.row.mainImages}
                className="h-[7vh] w-[6vw] object-contain mr-2"
                alt="Product Image"
              />
            )} */}
          </div>
        );
      },
    },

    {
      field: "categoryId",
      headerName: "Ctg. Name",
      width: 150,
      // editable: true,
    },

    // {
    //   field: "categoryId",
    //   headerName: "Ctg. Id",
    //   width: 150,
    //   // editable: true,
    // },
    {
      field: "storeName",
      headerName: "Store Name",
      width: 150,
      // editable: true,
      editable: false,
    },

    {
      field: "defaultPrice",
      headerName: "¥",
      width: 90,
      editable: true,
    },

    {
      field: "totalQuantity",
      headerName: "Quantity",
      width: 90,
    },
    {
      field: "somani",
      headerName: "SM",
      width: 90,
    },
    {
      field: "mOQ",
      headerName: "MOQ",
      width: 90,
      editable: true,
    },
    {
      field: "unit",
      headerName: "Unit",
      width: 90,
      editable: false,
    },
    // {
    //   field: "qtyInStock",
    //   headerName: "Stock",
    //   width: 90,
    //   editable: true,
    // },
    // {
    //   field: "saleprice",
    //   headerName: "Sale price",
    //   width: 90,
    //   editable: true,
    // },

    // {
    //   field: "price",
    //   headerName: "Price",
    //   width: 90,
    //   editable: true,
    // },
    {
      field: "salePrice",
      headerName: "Sales Price",
      width: 90
    },

    {
      field: "createdAt",
      headerName: "Created Date Time",
      width: 200,
      editable: false,
    },
    {
      field: "updatedAt",
      headerName: "Updated at (Time)",
      width: 200,
      editable: false,
    },
    // {
    //   field: "updatedBy",
    //   headerName: "Updated By",
    //   width: 150,
    // },
    {
      field: "status",
      headerName: "Status",
      width: 150,
      // editable: true,
      type: "singleSelect",
      valueOptions:[
        { value: 'true', label: 'Enabled' },
        { value: 'false', label: 'Disabled' }
      ],
      valueFormatter: (params) => (params.value ? "Enabled" : "Disabled"),
      // getActions: (params) => {
      //   const isInEditMode = rowModesModel[params.id]?.mode === GridRowModes.Edit;

      //   if (isInEditMode) {
      //     return [
      //       <select
      //       key="select-status"
      //       style={{ width: "7vw", height: "3vh", border: "none" }}
      //       name=""
      //       id=""
      //       defaultValue="true" 
      //       onChange={(event) => handleStatusChange(params.id, event.target.value)}
      //     >
      //       <option value={true}>Enabled</option>
      //       <option value={false}>Disabled</option>
      //     </select>
      //     ];
      //   } else {
      //     return null;
      //   }
      // },
    },

    {
      field: "action",
      headerName: "Action",
      description: "This column has a value getter and is not sortable.",
      sortable: false,
      width: 180,
      renderCell: ProductRenderingColumn,
      valueGetter: (params) => `${params.row.Name || ""} ${params.row.lastName || ""}`,
    },

    {
      field: "actions",
      type: "actions",
      headerName: "Quick Edit",
      width: 100,
      cellClassName: "actions",
      getActions: (params) => {
        let isInEditMode = rowModesModel[params.id]?.mode === GridRowModes.Edit;

        if (isInEditMode) {
          return [
            <GridActionsCellItem
              icon={<SaveIcon />}
              label="Save"
              sx={{
                color: "green",
              }}
              onClick={(e) => {
                // isInEditMode=false;
                const rowWithoutImage = Object.entries(params.row).reduce((acc, [key, value]) => {
                  if (key !== "image") {
                    acc[key] = value;
                  }
                  return acc;
                }, {});
                console.log( params.row,'@@@@@@');
                handleSubmit(params.id, params.row);
                // window.location.reload();
              }}
            />,
            <GridActionsCellItem
              icon={<CancelIcon/>}
              label="Cancel"
              className="textPrimary"
              onClick={handleCancelClick(params.id)}
              color="inherit"
            />,
          ];
        }
        return [
          <GridActionsCellItem
            icon={<EditIcon className="text-blue-400" />}
            label="Edit"
            className="textPrimary"
            onClick={handleEditClick(params.id)}
            color="inherit"
          />,
        ];
      },
      valueGetter: (params) => `${params.row.Name || ""} ${params.row.lastName || ""}`,
    },

  
  ];

  const columnsWithoutId = columns.filter((columns) => columns.field !== "id");

  // console.log("======", rows);

  // const handleSubmit = async (e) => {
  //   e.preventDefault();
  //   const formData = new FormData();
  //   formData.append("file", file);
  //   formData.append("createdDate", createdDate.toISOString().split("T")[0]);
  //   formData.append("createdTime", createdTime);
  //   console.log("+++++");

  //   try {
  //     setFormLoading(true);
  //     const res = await axios.post(`${baseURL}/product/upload-product`, formData);
  //     console.log(res);
  //     if (res.status === 200) {
  //       alert("Uploaded");
  //       setFormLoading(false);
  //       setFile("");
  //       // navigate("/");
  //     }
  //   } catch (error) {
  //     setFormLoading(false);
  //     alert("error");
  //     console.log(error);
  //   }
  // };

  // const [_id, set_Id] = useState("");
  // const [productId, setProductId] = useState("");
  // const handleDeleteConfirmation = async () => {
  //   try {
  //     const response = await fetch("https://jumunona.onrender.com/admin/products/deleteProduct/", {
  //       method: "POST",
  //       headers: {
  //         "Content-Type": "application/json",
  //       },
  //       body: JSON.stringify({
  //         productId: "65cc6b014ff46c7d69e467c3"
  //         // productId:"65cc6b054ff46c7d69e46813"
  //       }),
  //     });
  //     const data = await response.json();

  //     console.log(data); // Log the response data

  //     if (data.success) {
  //       // If the delete operation was successful, update deleteStatus
  //       setDeleteStatus(true);
  //       set_Id(""); // Clear the product ID after successful deletion
  //       window.location.reload();
  //     }
  //   } catch (error) {
  //     console.error("Error deleting product:", error);
  //     // Handle errors here
  //   }
  // };

  // const handleDeleteConfirmation = async (_id) => {
  //   console.log(_id, "aaaaaaaaaaaaaaaaa");
  //   try {
  //     const response = await fetch("https://jumunona.onrender.com/admin/products/deleteProduct/", {
  //       method: "POST",
  //       headers: {
  //         "Content-Type": "application/json",
  //       },
  //       body: JSON.stringify({
  //         productId: _id,
  //       }),
  //     });
  //     const data = await response.json();
  //     console.log(data);
  //     console.log("Product ID:", _id);
  //     console.log(_id, "AAAAAAAAAAA");

  //     if (data.success) {
  //       setDeleteStatus(true);
  //       set_Id("");
  //       setProductId("")
  //       window.location.reload();
  //     }
  //   } catch (error) {
  //     console.error("Error deleting product:", error);
  //   }
  // };

  // const handleDeleteButtonClick = () => {
  //   // Show confirmation popup
  //   const isConfirmed = window.confirm("Are you sure you want to delete this product?");
  //   if (isConfirmed) {
  //     handleDeleteConfirmation(productId_id);
  //   }
  // };

  const handleCellEditChange = (updatedCell) => {
    const updatedRowsCopy = Userdata.map((row) => {
      if (row.id === updatedCell.id) {
        return { ...row, [updatedCell.field]: updatedCell.value };
      }
      return row;
    });
    setUserdata(updatedRowsCopy);
  };

  return (
    <DashboardLayout>
      <DashboardNavbar />
      {!tableData && <LoaderComponent open={true} />}
      {formLoading && <LoaderComponent open={true} />}
      <MDBox py={3}>
        {/* <div>
          <button
            onClick={() => navigate("/
            ")}
            style={{
              background: "crimson",
              color: "white",
              borderRadius: "5px",
              padding: "10px",
              border: "none",
              outline: "none",
              cursor: "pointer",
            }}
          >
            Add Product
          </button>

        </div> */}
        <form className="flex flex-col gap-10">
          <div className="flex gap-4" style={{justifyContent:"flex-end"}}>
            {/* <div className="flex flex-col gap-4">
              <label htmlFor="fileSelect">
                <span className="bg-green-700   rounded-md w-[10vw] cursor-pointer p-2 border-none outline-none ml-[1vw] text-white  text-sm">
                  Choose Excel file
                </span>
              </label>
              <input
                style={{ display: "none" }}
                type="file"
                id="fileSelect"
                onChange={(e) => setFile(e.target.files[0])}
                accept=".xlsx, .xls, .csv"
              />
              <span className="text-sm">{file.name}</span>
              {file && (
                <button
                  type="submit"
                  className="bg-green-700 rounded-md cursor-pointer p-2 border-none outline-none w-[15vw] text-white"
                >
                  Submit
                </button>
              )}
            </div> */}

            <div className="flex flex-col gap-4" >
              <label htmlFor="fileSelect">
                <span className="bg-green-700 rounded-md w-[10vw] cursor-pointer p-2 border-none outline-none ml-[1vw] text-white text-sm">
                  Choose Excel file
                </span>
              </label>
              <input
                style={{ display: "none" }}
                type="file"
                id="fileSelect"
                onChange={handleFileChange}
                accept=".xlsx, .xls, .csv"
              />
              <span className="text-sm">{file?.name}</span>
              {file && (
                <Button
                  variant="contained"
                  color="primary"
                  onClick={handleSubmitFile}
                  sx={{ color: "white !important" }}
                >
                  Submit
                </Button>
              )}

              {console.log(uploadingFile, "uploadingFile")}
            </div>

            {/* <span>{file.name}</span> */}
            <div className="flex gap-4">
              <label>
                <span
                  onClick={() => navigate("/new_product")}
                  type="button"
                  className="p-2 h-[5vh] cursor-pointer rounded-md w-[8vw] text-sm text-white border-none outline-none bg-blue-700"
                >
                  Upload Manually
                </span>
              </label>
            </div>
          </div>
          <div className="flex " style={{ width: "400px" }}>
            {uploadingFile !== 0 && (
              <Box sx={{ width: "100%" }}>
                <LinearProgressWithLabel value={uploadingFile} />
              </Box>
            )}
          </div>
        </form>
        {allIds.length > 0 && (
          <label>
            <label>
              <span
                // onClick={handleDeleteButtonClick}
                onClick={() => {
                  const _id = rows._id;
                  console.log({ state: { productId: _id } });
                  // Further actions can be performed here if needed
                }}
                className="bg-red-700 h-[5vh] rounded-md w-[10vw] text-sm cursor-pointer p-2 border-none outline-none ml-[1vw] text-white"
              >
                Delete Selected
                {deleteStatus && <p>Item deleted successfully!</p>}
              </span>
            </label>
          </label>
        )}

        <div>
          <Box sx={{ height: 540, width: "100%", background: "white", marginTop:"-3%"}}>
            {loading ? (
              <div
                style={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  height: "400px",
                }}
              >
                <ReactLoading type="spin" color="black" height={100} width={40} />
              </div>
            ) : (
              <DataGrid
                rows={rows}
                rowCount={totalRows}
                columns={columns}
                initialState={{
                  pagination: {
                    paginationModel: {
                      pageSize: 10,
                      page: 1,
                    },
                  },
                }}
                rowModesModel={rowModesModel}
                page={page}
                // setPage={setPage}
                pagination
                paginationMode="server"
                onRowModesModelChange={handleRowModesModelChange}
                onRowEditStop={handleRowEditStop}
                processRowUpdate={processRowUpdate}
                pageSizeOptions={[5, 10, 25, 100]}
                checkboxSelection
                experimentalFeatures={{ newEditingApi: true }}
                onRowSelectionModelChange={(_ids) => onRowsSelectionHandler(_ids)}
                onPaginationModelChange={(newPage) => setPage(newPage)}
                disableRowSelectionOnClick
                // onCellKeyDown={(e) => console.log(e.target.value, "vaaaal")}
                onCellKeyDown={(e) => console.log(e, "vaaaal")}
                // onCellEditCommit={(params) => {
                //   const { id, field, value } = params;
                //   console.log(params, "AAAABBBBBB");
                //   if (field === "mOQ") {
                //     setMOQ(value);
                //   }
                //   // Handle other field edits if needed
                // }}
                onEditCellChange={handleCellEditChange}
                // editable={true} // Enable editing
                // onCellEditCommit={(params) => handlePriceChange(params)}
              />
            )}
          </Box>
        </div>
      </MDBox>
      <Footer />
    </DashboardLayout>
  );
}

export default MasterProductList;